import React from "react";
import LossTable from "../components/LossTable";

export function General({fullData}) {
	return(
		<LossTable data={fullData}/>
	);
}
